import React, { useState, useRef, useEffect } from "react";
import { Button, CircularProgress, Grid } from "@mui/material";
import {LoginContainer, LogoBox, ForgotPasswordDetails} from './Authorization.style'
import ThemeColor from "../../theme/ThemeColor";
import { H3SubHeader, H3MainText, H7TablePrimeContent } from "../../theme/Theme";
import { CustemButton, InputBox } from "../../components/Custom"
import SideBarAuthorization from "./SideBarAuthorization"
import { Link, useLocation, useNavigate } from "react-router-dom"
import LessThanIcon from "../../components/Icons/LessThanIcon"
import Swal from "sweetalert2"
import { emailSend, verifiedOtp } from "../../redux/Thunk/authThunk"
import { useDispatch } from "react-redux"
import image from "../../asserts/LALogistic-1.png"
import SignInImage from "../../asserts/LoginImage.jpg";

const SendOTP = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false)
  const [otp, setOtp] = useState(new Array(4).fill("")); // Array to store OTP digits
  const inputRefs = useRef([]); // Refs to control focus on inputs
  const [timer, setTimer] = useState(30); // Timer state
  const [isResendDisabled, setIsResendDisabled] = useState(true); // Resend button disabled state
 
  // Focus cursor on the first input when the component loads
  useEffect(() => {
    inputRefs.current[0]?.focus();
    startTimer();
  }, []);
  
  // Timer countdown effect
  useEffect(() => {
    if (timer === 0) {
      setIsResendDisabled(false); // Enable the "Resent OTP" button
    }
    const countdown = timer > 0 && setInterval(() => setTimer(timer - 1), 1000);
    return () => clearInterval(countdown);
  }, [timer]);

  // Start the countdown timer again when "Resent OTP" is clicked
  const startTimer = () => {
    setTimer(30);
    setIsResendDisabled(true);
  };

  // Handle OTP change
  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (isNaN(value) || value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  // Handle backspace to move focus to the previous input
  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  // Handle OTP submission
  const handleClickOpt = () => {
    const details = {
      Email: state?.sendDetails?.Email,
      otp: otp.join("")
    };
    setLoader(true)
    dispatch(verifiedOtp(details)).then((res) => {
      setLoader(false)
      if (res.payload.success === true) {
        navigate("/resetpassword", { state: { Email: state?.sendDetails?.Email, otp: otp.join("")} });
      } else {
        Swal.fire({ title: res?.payload?.message, icon: "error" });
      }
    });
  };

  // Handle OTP resend
  const handleClickResetOtp = () => {
    setIsResendDisabled(true)
    dispatch(emailSend({Email: state?.sendDetails?.Email})).then((res) => {
      if (res?.payload?.success === true) {
        startTimer(); // Restart the timer
        Swal.fire({ title: res?.payload?.message, icon: "success"});
        setOtp(new Array(4).fill(""))
      } else {
        Swal.fire({ title: res?.payload?.message, icon: "error"});
      }
    });
  };

    return(
        <>
        <Grid container>
          <Grid size={{ xs: 12, sm: 10, md: 10, lg:8 }} style={{display:'flex', justifyContent:"center"}}>
            <img src={SignInImage} alt="Login" style={{ width: 'auto', height: '100vh', objectFit: 'cover'}} />
          </Grid>

           {/* Employee Forget Password Details */}
           <Grid size={{ xs: 12, sm: 10, md: 10, lg:4 }} style={{background:'#F1F1F1', borderBottomRightRadius:'10px', borderTopRightRadius:'10px', height:'auto', maxWidth:'100%'}}>
              <LogoBox>
                <img src={image} width={172} height={165} alt="" style={{objectFit: 'cover'}}/>
              </LogoBox>
              
              <ForgotPasswordDetails >
                <Grid container spacing={2} style={{display:'flex', marginTop:'10px', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
                {/* Display form */}
                  <Grid size={{ xs: 12, sm: 6, md: 6, lg:12}}>
                    <H3MainText sx={{fontSize:'20px', color: ThemeColor.palette.InputTextColor, textAlign:'center'}}>Recovery email has been sent to your resgistered account.</H3MainText>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 6, lg:12}}>
                    <H3SubHeader sx={{color: ThemeColor.palette.InputTextColor, textAlign:'center'}}>Enter OTP here</H3SubHeader>
                  </Grid>
                </Grid>

                <Grid container style={{display:'flex', marginTop:'10px', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
                  <Grid size={{ xs: 12, sm: 12, md: 12, lg:12}}>
                    {otp.map((digit, index) => (
                      <InputBox
                        key={index}
                        type="text"
                        value={digit}
                        inputProps={{ maxLength: 1 }}
                        autoFocus
                        inputRef={(el) => inputRefs.current[index] = el} 
                        onChange={(e) => handleOtpChange(e, index)}
                        onKeyDown={(e) => handleBackspace(e, index)}
                        sx={{fontSize: "29px", lineHeight: "50px", textAlign: "center", border: "2px solid gray", width: "60px", height: "50px", borderRadius: "15px", padding: "10px", margin: "5px",}}
                      />
                    ))}
                  </Grid>
                  <Grid item xs={12} md={10} sm={10} lg={10}>
                    <H3SubHeader 
                      sx={{mt:2, color: isResendDisabled ? "#bbb" : ThemeColor.palette.InputTextColor, cursor: isResendDisabled ? "not-allowed" : "pointer" }}
                      onClick={!isResendDisabled ? handleClickResetOtp : null}
                    >
                      Resent OTP {isResendDisabled && `(${timer}s)`}
                    </H3SubHeader>
                  </Grid>
                    {/* <CustemButton onClick={handleClickOpt} variant="contained" id ='submit' text="Submit" backgroundColor={ThemeColor.palette.ButtonColor} sx={{borderRadius:'10px', fontSize:'16px', letterSpacing:'1px', pl:5, pr:5, pt:1.5, pb:1.5, fontWeight:600, margin:'40px 0px'}}/> */}
                    <Button
                      id="validate"
                      variant="contained"
                      disabled={loader}
                      onClick={handleClickOpt}
                      sx={{
                        color: '#FFFFFF',
                        backgroundColor: '#3107AA',
                        '&:hover': { backgroundColor: '#3107AA', color: '#FFFFFF' },
                        fontSize: '16px', 
                        fontWeight: '500',
                        borderRadius:"10px",
                        textTransform: 'none', 
                        width:'100%', height:'40px',
                        margin:'15px',
                        boxShadow:'0px 4px 6px #e1e1e1'
                      }}
                      >
                      {loader ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
                  </Button>
                </Grid> 
              
                <Link to='/' style={{textDecoration:'none'}} >
                  <H7TablePrimeContent display='flex' justifyContent='start' sx={{color:ThemeColor.palette.TableButton, textAlign:'start'}}>
                    <LessThanIcon/> Back to Login
                  </H7TablePrimeContent>
                </Link>

              </ForgotPasswordDetails> 
          </Grid>  
        </Grid>
      </>
    )
}

export default SendOTP